import React, {useLayoutEffect} from 'react';
import styled from 'styled-components';
import PropTypes from "prop-types";
import Navigation from "../molecules/Navigation";

const Holder = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background-color: ${props => props.theme.colours.white};
  padding: 5.6rem 2rem 2rem 2rem;
  width: 100%;
  z-index: 9;
  transform: ${props => props.show ? 'none' :'translateY(-100%)'};
  transition: transform 0.25s ease-in-out;
  @media( ${props => props.theme.breakpoints.md} ) {
    display: none;
  }
  ul {
    opacity: ${props => props.show ? 1 : 0};
    transition: opacity 0.25s 0.25s ease-in-out;
  }
`;

function SmallNavigation({show, clickHandler}) {

  useLayoutEffect(() => {
    if(show) {
      // Get original body overflow
      const originalStyle = window.getComputedStyle(document.body).overflow;
      // Prevent scrolling on mount
      document.body.style.overflow = "hidden";
      // Re-enable scrolling when component unmounts
      return () => (document.body.style.overflow = originalStyle);
    }
  }, [show])

  return (
    <Holder show={show}>
      <Navigation clickHandler={clickHandler}/>
    </Holder>
  )
}

SmallNavigation.propTypes = {
  show: PropTypes.bool.isRequired,
  clickHandler: PropTypes.func.isRequired
};

export default SmallNavigation;